import { styled } from '@mui/system';
import Grid from '@mui/material/Grid';
import Autocomplete from '@mui/material/Autocomplete';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { TextField } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import RedoIcon from '@mui/icons-material/Redo';
import { Link } from 'react-router-dom';

// Grids
export const Container = styled(Grid)({
  width: '100%',
  padding: '24px',
  backgroundColor: 'white',
  boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
  borderRadius: '8px',
});

export const PlaceholderContainer = styled(Grid)({
  maxWidth: '1000px',
});

export const NameContainer = styled(Grid)({
  marginBottom: '16px',
});

export const InsideGrid = styled(Grid)({
  maxWidth: '75px !important',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const PlaceholderRow = styled(Grid)({
  marginBottom: '8px',
});

// Divs //
export const InputLabel = styled('div')({
  fontSize: '14px',
  lineHeight: '19px',
  color: 'var(--color-text-primary)',
  margin: '18px 0px 8px 0px',
});

export const PlaceholderTextField = styled(TextField)(() => ({
  fontSize: '14px',
  '& .MuiInputBase-root.Mui-disabled': {
    backgroundColor: '#FAFAFA',
    '& .MuiInputBase-input.Mui-disabled': {
      color: 'var(--color-text-primary)',
      opacity: 0.7,
      WebkitTextFillColor: 'var(--color-text-primary)',
    },
    '& fieldset': {
      borderColor: '#BBBBBB',
    },
  },
}));

// Spans //
export const BlueText = styled('span')({
  fontSize: '14px',
  color: 'var(--color-text-primary)',
  margin: '0px 3px',
  '&:hover': {
    color: 'rgba(33, 150, 243, 0.75)',
  },
});

export const BlueTextCenter = styled('span')({
  fontSize: '14px',
  color: 'var(--color-text-primary)',
  margin: '0px 3px',
  '&:hover': {
    color: 'rgba(33, 150, 243, 0.75)',
  },
  display: 'flex',
  alignItems: 'center',
});

export const BoldText = styled('span')({
  fontWeight: 'bold',
});

export const PlaceholderHeader = styled('span')({
  fontSize: '14px',
  lineHeight: '16px',
});

export const ConnectionText = styled('span')({
  fontSize: '14px',
  lineHeight: '19px',
  color: '#343434',
});

export const OpenWorkflowText = styled('span')({
  fontSize: '14px',
  lineHeight: '19px',
  color: '#343434',
  display: 'flex',
  alignItems: 'center',
  marginTop: '16px',
});

export const ErrorText = styled('div')({
  fontSize: '14px',
  lineHeight: '19px',
  color: '#b00020',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  marginTop: '24px',
});

export const StyledErrorIcon = styled(ErrorIcon)({
  color: '#b00020',
  marginRight: '8px',
});

// Icons //
export const StyledArrow = styled(ArrowRightAltIcon)({
  color: '#757575',
});

export const StyledOpenInNewIcon = styled(OpenInNewIcon)({
  width: '15px',
  height: '15px',
  marginRight: '4px',
});

// Autocompletes //
export const Dropdown = styled(Autocomplete)(({ theme }) => ({
  maxWidth: '650px',
  backgroundColor: `${theme.palette.background.paper} !important`,
}));

export const DropdownContainer = styled('div')({
  maxWidth: '100%',
  overflow: 'hidden',
});

export const BlackRedoIcon = styled(RedoIcon)({
  marginRight: '8px',
  color: 'var(--color-text-primary)',
});

export const StyledLink = styled(Link)({
  textDecoration: 'none',
});
